module.exports = __webpack_public_path__ + "img/ch83.a34c69c9.png";